import {AssertUtils, GoingNewUtils} from "xmgoing-utils";

const getXmInputJson=(itemDb)=>{
  const propsKey=GoingNewUtils.getUUChar(23);
  return {
    "componentKey": itemDb.fieldType||"xmInput",
    "label": itemDb.fieldName,
    "styles": {
      "marginBottom": "2"
    },
    "props": {
      "width": "100%",
      "height": "auto",
      "label":  itemDb.fieldName,
      "size": "middle",
      "key": propsKey,
      "pageSize": 10,
      "gridSize": "default",
      "pItem": "xmForm",
      "pItemType": "",
      "labelPosition": "",
      "textAlign": "",
      "required": AssertUtils.parseBoolean(itemDb.required),
      "trigger": ""
    },
    "children": [],
    "events": [],
    "model": {
      "entityKey": "state",
      "key": itemDb.fieldId,
    },
    "_vid":propsKey,
    "icon": "remix-icon ri-danhangshurukuang",
    "key": propsKey
  }
}
const parseOptionsDataList = function (options: any) {
  if (options == null || options === '') {
    return null;
  }
  if (Array.isArray(options)) {
    return options;
  }
  if (typeof options === 'string') {
    try {
      const parsed = JSON.parse(options);
      return Array.isArray(parsed) ? parsed : null;
    } catch (e) {
      console.error(options, '=====自定义字段options解析错误');
      return null;
    }
  }
  return null;
};

/**
 * 补齐 xmSelect 自定义字段的静态选项配置（子表/材料选择子表下拉展示依赖 dataConfig.dataList）
 * @param itemDbObj
 * @param rawItemDb 接口原始记录或缓存字段，含 options / _fieldOptions 时可兜底解析
 */
export const normalizeUserDefSelectField = function (itemDbObj: any, rawItemDb?: any) {
  const componentKey = itemDbObj.componentKey || itemDbObj.props?.componentKey || itemDbObj.propType;
  if (componentKey !== 'xmSelect') {
    return;
  }
  if (itemDbObj.props) {
    itemDbObj.props.showSearch = true;
  }
  // 接口里 multiple 常为字符串 "true"；表单读 props.multiple，表格列把列根当 props
  const multipleSource =
    rawItemDb?.multiple ??
    rawItemDb?.props?.multiple ??
    itemDbObj?.props?.multiple ??
    itemDbObj?.multiple;
  const multipleVal = AssertUtils.parseBoolean(multipleSource);
  itemDbObj.multiple = multipleVal;
  if (itemDbObj.props) {
    itemDbObj.props.multiple = multipleVal;
  }
  if (itemDbObj.dataConfig == null) {
    itemDbObj.dataConfig = {};
  }
  itemDbObj.dataConfig.dataFormType = 'static';
  if (!itemDbObj.dataConfig.dataList && rawItemDb?.dataConfig?.dataList) {
    const cachedList = parseOptionsDataList(rawItemDb.dataConfig.dataList);
    if (cachedList) {
      itemDbObj.dataConfig.dataList = cachedList;
    }
  }
  if (!itemDbObj.dataConfig.dataList) {
    const optionsSource = rawItemDb?.options || rawItemDb?._fieldOptions;
    const parsedList = parseOptionsDataList(optionsSource);
    if (parsedList) {
      itemDbObj.dataConfig.dataList = parsedList;
    }
  }
  if (typeof itemDbObj.dataConfig.dataList === 'string') {
    const parsedList = parseOptionsDataList(itemDbObj.dataConfig.dataList);
    if (parsedList) {
      itemDbObj.dataConfig.dataList = parsedList;
    }
  }
};

/**
 * 确保 xmSelect 列的 dataList 已解析（所有表格类型），
 * 并为子表/材料选择子表补齐可编辑下拉所需的 controlType。
 */
export const applySubTableSelectColConfig = function (itemDb: any, ctlFromVal: string) {
  const componentKey = itemDb.propType || itemDb.componentKey;
  const isSelectCol = componentKey === 'xmSelect' || itemDb.controlType === 'SelectEditor' || itemDb.controlType === 'xmSelect';
  if (!isSelectCol) {
    return;
  }
  // 所有场景：确保 dataList 已解析，只读展示翻译依赖此数据
  normalizeUserDefSelectField(itemDb);
  // 仅子表/材料选择子表需要进一步补齐为可编辑 SelectEditor
  if (ctlFromVal !== 'xmSubTable' && ctlFromVal !== 'materialsSel') {
    return;
  }
  if (!itemDb.controlType || itemDb.controlType === 'xmSelect') {
    itemDb.controlType = 'SelectEditor';
  }
  if (!itemDb.ctlName) {
    itemDb.ctlName = 'cellEditor';
    itemDb.showContent = itemDb.showContent || 'cellContent';
  }
};

/**
 * 获取字段信息
 * @param itemDb
 */
const getFieldJson=function (itemDb){
  return getXmInputJson(itemDb);
}
export default getFieldJson;
